import { Typography } from '@recruit-robin/robin-theme/web-components';
import { useContext } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { JobFormValues } from '../../EditEnrichedVacancy.types';
import { useStyles } from './FormSections.styles';

export type ControllerRenderArgs = {
  onChange: (...event: any[]) => void;
  onBlur: () => void;
  value: any;
  name?: string;
  ref?: React.Ref<any>;
};

type RenderFieldProps = {
  label?: string;
  fieldName: string;
  render: (props: ControllerRenderArgs) => JSX.Element;
  defaultValue?: any;
  required?: boolean;
  validate?: (value: any) => string | true;
};

export const RenderField = ({ label, fieldName, render, defaultValue, required, validate }: RenderFieldProps) => {
  const classes = useStyles();
  const { control, trigger } = useFormContext<JobFormValues>();
  const { dictionary } = useContext(LocalizationContext);

  return (
    <div css={classes.formField}>
      {label && (
        <Typography variant={(v) => v.supporting.label} color={(c) => c.neutral.variant[70]}>
          {required && <span css={classes.required}>* </span>}
          {label}:
        </Typography>
      )}
      <Controller
        name={fieldName}
        control={control}
        render={(data) => {
          const value = data.value === null || data.value === undefined ? '' : data.value;
          return render({
            ...data,
            value,
            onBlur: async () => {
              await trigger(fieldName);
              data.onBlur();
            },
          });
        }}
        defaultValue={defaultValue}
        rules={
          required || validate
            ? {
                ...(required ? { required: dictionary.thisFieldIsRequiredError } : {}),
                ...(validate ? { validate } : {}),
              }
            : undefined
        }
      />
    </div>
  );
};
